// extracted by mini-css-extract-plugin
export default {"container":"MainLayout_container__6qfQd","navigationBar":"MainLayout_navigationBar__6luAG","page":"MainLayout_page__82zmx"};